import type { FluxErrorEntityErrorCodes } from '../types.js';

export const AccountErrorCodes = {
  AccountNotFound: {
    code: 'account/not-found',
    message: 'A conta especificada não foi encontrada.',
    explanation: `Esse erro ocorre quando a **conta solicitada não existe** no sistema ou não está acessível no contexto atual.

**Cenários comuns:**
- O **ID da conta está incorreto** ou foi digitado errado
- A conta foi **deletada** ou desativada
- Você está tentando acessar uma conta que não seja a sua

**Como diagnosticar:**
Verifique se o \`account_id\` está correto.`,
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'account'>;
